import { ReactElement } from 'react';
import { Message } from '@messageformat/react';

interface Props {
  sum: number;
  messageId: string;
}

const TotalTile = (props: Props): ReactElement => {
  const { sum, messageId } = props;
  return (
    <div className="investoracademy-dreams-tile">
      <div style={{ display: 'flex' }}>
        <span
          className="opds-styles-v1-text-title-small-strong"
          style={{ textAlign: 'center', alignSelf: 'stretch' }}
        >
          <Message id={`${messageId}`} />
        </span>
      </div>
      <div className="opds-styles-v1-text-hero-small">
        <span className="investoracademy-highlight-total ">
          {sum.toLocaleString('fi') === '0' ? '-' : sum.toLocaleString('fi')} €
        </span>
      </div>
    </div>
  );
};

export default TotalTile;
